var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inlineGallery"},_vm._l((_vm.currentPlayerImages),function(image,index){return _c('InlineGalleryCard',{key:index,attrs:{"path":image.path}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }